<template>
    <div v-if="filteredTrays?.length" class="p-6">
        <h3 class="mb-4 text-v2-gray-80 text-sm font-medium">Trays ({{ filteredTrays.length ?? 0 }})</h3>
        <div v-if="searchIsLoading" class="w-full flex flex-col gap-2 items-center h-full">
            <div class="rounded loading-value h-[85px] w-full" />
            <div class="rounded loading-value h-[85px] w-full" />
            <div class="rounded loading-value h-[85px] w-full" />
            <div class="rounded loading-value h-[85px] w-full" />
        </div>
        <ul v-else-if="!searchIsLoading && filteredTrays?.length" class="space-y-2">
            <PinTray v-for="tray in filteredTrays" :tray="tray" />
        </ul>
        <div v-else-if="!searchIsLoading && !filteredTrays.length && searchInput.length">
            No results
        </div>
    </div>
    <div v-else-if="searchIsLoading" class="w-full flex flex-col gap-2 items-center h-full">
        <div class="rounded loading-value h-[85px] w-full" />
        <div class="rounded loading-value h-[85px] w-full" />
        <div class="rounded loading-value h-[85px] w-full" />
        <div class="rounded loading-value h-[85px] w-full" />
    </div>
</template>

<script setup>
import {PinTray} from "@/Components/Modules/Dialogs/Pins/Components";
import {usePinsDrawer} from "@/Composables";
import {computed} from "vue";
import _ from 'lodash';

const { drawer, searchIsLoading } = usePinsDrawer();
const props = defineProps(['searchInput']);

const filteredTrays = computed(() => {
    let trays = drawer.value?.trays || [];
    if(props.searchInput?.length) {
        trays = trays.filter(tray => {
            return tray?.name?.toLowerCase()?.includes(props.searchInput?.toLowerCase());
        });
    }
    return _.orderBy(trays, [
        tray => tray.name === 'Favorites' ? 0 : 1, // Favorites gets priority 0, others get 1
        'updated_at' // Then sort by updated_at
    ], ['asc', 'desc']); // Ascending for priority, descending for date
});
</script>
